/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const zIndex = {
  accessoryDrawer: 1080,
  appBar: 1100,
  appSidebar: 1060,
  drawer: 1200,
  fab: 1050,
  mobileStepper: 1000,
  modal: 1300,
  snackbar: 1400,
  speedDial: 1050,
  toolbar: 1050,
  tooltip: 1500,
} as const;
